/**
 * Studio Hub Competitors 页面下载表单配置
 * @description CasualCompetitors 页面的下载弹窗表单配置
 */

/**
 * Data Calculation 子表单配置
 * @description 包含 Time Settings、Region Settings、Ratio 开关
 */
const dataCalculationFormList = {
  label: 'dbi_label_data_calculation',
  type: 'subForm',
  children: [
    {
      label: 'dbi_label_edition_settings',
      type: 'checkboxGroup',
      defaultValue: ['aggregated'],
      field: 'edition_method',
      options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
    },
    {
      label: 'dbi_label_time_settings',
      type: 'radio',
      defaultValue: 'aggregated',
      field: 'date_method',
      message: 'dbi_label_time_settings_tips',
      options: [
        { label: 'dbi_label_aggregated', value: 'aggregated' },
        { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
      ],
    },
    {
      label: 'dbi_label_region_settings',
      type: 'radio',
      field: 'region_method',
      defaultValue: 'aggregated',
      options: [
        { label: 'dbi_label_aggregated', value: 'aggregated' },
        { label: 'dbi_label_separate_by_country_combine', value: 'market' },
        { label: 'dbi_label_separate_by_region_combine', value: 'region' },
      ],
    },
    {
      label: 'dbi_label_ratio',
      type: 'switch',
      defaultValue: true,
      field: 'ratio_show',
      options: [],
    },
  ],
};

export default {
  // 关注游戏下载配置
  casualCompetitorsKeyGames: {
    apiUrl: '',
    bubbleText: '',
    translate: true,
    formList: [dataCalculationFormList],
  },
  // 头部厂商下载配置
  casualCompetitorsTopPublishers: {
    apiUrl: '',
    bubbleText: '',
    translate: true,
    formList: [dataCalculationFormList],
  },
};
